import { createStore, applyMiddleware,compose } from "redux";
import { persistStore } from "redux-persist";
//import { composeWithDevTools } from "redux-devtools-extension";
//import thunk from "redux-thunk";
import {thunk} from "redux-thunk";
import rootReducer from "../utils/rootReducer";
const middleware = [thunk];
export const store = createStore(
  rootReducer,
  compose(applyMiddleware(...middleware))
);
export const persistor = persistStore(store);
